import React from 'react'

export default function Appright() {
  return (
    <div>
            <div className="col card-title">
                <h1 className='titleHello text-center text-md-start'>Hola👋</h1>
                <p className="paraAbout justify-centre-small">I am <span className='paraAboutKapil'>Kapil.</span> </p>
                    {/* <br/> I 
                    code, design, illustrate and travel the world 🌏
                    <br/> More importantly, I love to meet awesome people, such as you!
                </p>
                <button> Heyyy </button> */}

              <div class="slider-wrapper paraAbout">  
                   I
                <div class="slider">
                  <div class="slider-text1">Code</div>
                  <div class="slider-text2">Design</div>
                  <div class="slider-text3">Illustrate</div>                  
                  <div class="slider-text4">Travel the World</div>
                  <div class="slider-text100">Code</div>
                </div>
              </div>    
        
        </div>

        <p className='paraAbout'>& love to meet awesome people, <br/>such as you! </p>
        
        <div className='lets-go'>
        {/* <button type="button" class="btn btn-outline-light">Let's gooo! Spiderman</button> */}
        <a href="https://www.linkedin.com/in/kapilananth/" target="_blank" className='link-light'> 
        <div className="button-cta d-flex justify-content-center text-center"> <p id='cta-link'>Let's do this  <i class="bi bi-arrow-right"></i></p> </div>
        </a>
        </div>

    </div>
  )
}
